













import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'

@Component
export default class RearrangeList extends Vue {
  @Prop({ required: true })
  private value!: any[]

  @Prop({ type: Function, default: () => true })
  private filter!: (v: any) => boolean

  @Prop({ type: Boolean, default: false })
  private table!: boolean

  private items = this.value

  get filteredItems() {
    return this.items.filter(this.filter)
  }

  @Watch('value', { deep: true })
  private valueChanged(val: any[], old: any[]) {
    if (val !== old) {
      this.items = val
    }
  }

  private up(index: number) {
    if (index > 0) {
      const sel = this.items[index]
      const adj = this.items[index - 1]
      this.items.splice(index - 1, 2, sel, adj)
      this.$emit('input', this.items)
      this.$emit('move:up', index, sel, adj)
    }
  }

  private down(index: number) {
    if (index < this.items.length - 1) {
      const sel = this.items[index]
      const adj = this.items[index + 1]
      this.items.splice(index, 2, adj, sel)
      this.$emit('input', this.items)
      this.$emit('move:down', index, sel, adj)
    }
  }
}
